import React from "react";
import {
  IconCircleCheck,
  IconCheck,
  IconSchool,
  IconBrandWhatsapp,
  IconRobot,
  IconMessageCircle,
} from "@tabler/icons-react";

// ===============================================
// CHECKLIST DE PROXIMOS PASSOS
// ===============================================

const NEXT_STEPS = [
  { icon: IconSchool, text: "Assistir as aulas essenciais no Aprendizado" },
   { icon: IconRobot, text: "Criar seu primeiro agente" },
  { icon: IconBrandWhatsapp, text: "Conectar seu WhatsApp" },
  { icon: IconMessageCircle, text: "Fazer seu primeiro atendimento" },
];

// ===============================================
// COMPLETION STEP COMPONENT
// ===============================================

const CompletionStep = () => {
  return (
    <>
      <div className="onb-card__header onb-card__header--with-icon">
        <div className="onb-card__icon onb-card__icon--success">
          <IconCircleCheck size={28} />
        </div>
        <h2 className="onb-card__title">Você está pronto!</h2>
        <p className="onb-card__subtitle">
          Aqui está seu checklist para começar com sucesso
        </p>
      </div>

      <div className="onb-card__body">
        <div className="onb-checklist">
          {NEXT_STEPS.map((step, index) => (
            <div key={index} className="onb-checklist__item">
              <div className="onb-checklist__check">
                <IconCheck size={12} />
              </div>
              <step.icon size={18} style={{ color: "#64748b", flexShrink: 0 }} />
              <span>{step.text}</span>
            </div>
          ))}
        </div>

        <div className="onb-highlight">
          <IconSchool size={18} className="onb-highlight__icon" />
          <span className="onb-highlight__text">
            Recomendamos fortemente que você comece pelas aulas no
            Aprendizado. Esse é o caminho mais rápido para dominar a
            plataforma.
          </span>
        </div>
      </div>
    </>
  );
};

export default CompletionStep;
